import PropTypes from 'prop-types';
export const defaultPropTypes = {
    size: PropTypes.number,
    appearance: PropTypes.string,
    fill: PropTypes.string,
};
